import { render } from "./DashboardCombustibleView.vue?vue&type=template&id=1590fbf4&scoped=true"
import script from "./DashboardCombustibleView.vue?vue&type=script&lang=js"
export * from "./DashboardCombustibleView.vue?vue&type=script&lang=js"

import "./DashboardCombustibleView.vue?vue&type=style&index=0&id=1590fbf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1590fbf4"]])

export default __exports__